<script>
import formatDate from '@utils/format-date'
import { messageSuccess } from "@utils/message"
import formMixin from "@components/Form/mixins/form";
import _cloneDeep from "lodash/cloneDeep"

const DEFAULT_SUBMIT_DATA = {
  name: '',
  phone: '',
  email: '',
};

export default {
  components: {
    MemberLayout: () => import("./components/Layout.Jtails"),
  },
  mixins: [formMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return { ...DEFAULT_SUBMIT_DATA }
      },
    },
    type: {
      type: String,
      default: 'add',
      validator(value) {
        return [
          'add',
          'edit',
        ].includes(value)
      },
    },
    memberInfo: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      errorMessage: '',
    }
  },
  created() {
    const initFormMixSubmitData = () => {
      this.FormMixSubmitData.name = this.memberInfo.name || DEFAULT_SUBMIT_DATA.name
      this.FormMixSubmitData.phone = this.memberInfo.phone || DEFAULT_SUBMIT_DATA.phone
      this.FormMixSubmitData.email = this.memberInfo.email || DEFAULT_SUBMIT_DATA.email
    };

    initFormMixSubmitData();
    this.$FormMixinInitTempSubmitData();
  },
  methods: {
    formatDate,
    onCancel() {
      this.$emit('cancel')
    },
    onSubmit() {
      this.tryToStoreInfo();
    },
    tryToStoreInfo() {
      this.$store.dispatch('wordpress/storeMember', {
        ...this.memberInfo,
        ...this.FormMixSubmitData
      })
        .then(() => {
          messageSuccess('已儲存');
          this.$FormMixinOnSubmitSuccess();
          this.$FormMixinInitTempSubmitData();
        })
    },
  }
}
</script>
<!-- section template -->
<template>
  <MemberLayout
    :class="$style.viewMemberInfo"
    title="會員設定"
    type="list"
  >
    <ValidationObserver v-slot="{ invalid, handleSubmit }">
      <el-form
        ref="form"
        :model="FormMixSubmitData"
        label-position="top"
        class="isStyleBase"
        :class="$style.formInfo"
        @submit.prevent.native="handleSubmit(onSubmit)"
      >
        <div class="mb-5">
          <ValidationProvider
            v-slot="{ errors }"
            name="姓名"
            rules="require"
          >
            <el-form-item :error="errors[0]" prop="name" label="姓名" class="isRequired">
              <!-- <div class="d-flex">
                <div style="flex: 1">
                  <el-input
                    v-model="FormMixSubmitData.fullName"
                    placeholder="例：王小明"
                  >
                  </el-input>
                </div>
                <div class="pl-3 pl-md-4" style="flex-shrink: 0">
                  <el-radio-group
                    v-model="FormMixSubmitData.gender"
                    class="isStyleBase"
                  >
                    <el-radio label="male">先生</el-radio>
                    <el-radio label="female">小姐</el-radio>
                  </el-radio-group>
                </div>
              </div> -->
              <el-input
                v-model="FormMixSubmitData.name"
                placeholder="例：王小明"
              >
              </el-input>
            </el-form-item>

          </ValidationProvider>
          <el-row :gutter="20">
            <el-col :span="24">
              <ValidationProvider
                v-slot="{ errors }"
                name="手機號碼"
              >
                <el-form-item :error="errors[0]" prop="phone" label="手機號碼" class="isRequired">
                  <el-input
                    v-model="FormMixSubmitData.phone"
                    placeholder="手機號碼"
                    disabled
                  >
                  </el-input>
                </el-form-item>
              </ValidationProvider>
            </el-col>
            <!-- <el-col :span="12">
              <ValidationProvider
                v-slot="{ errors }"
                name="LINE ID"
                rules=""
              >
                <el-form-item :error="errors[0]" prop="lineId" label="LINE ID">
                  <el-input
                    v-model="FormMixSubmitData.lineId"
                    placeholder="LINE ID"
                  >
                  </el-input>
                </el-form-item>
              </ValidationProvider>
            </el-col> -->
          </el-row>
          <ValidationProvider
            v-slot="{ errors }"
            name="電子郵件"
            rules="email"
          >
            <el-form-item :error="errors[0]" prop="email" label="電子郵件(E-mail)">
              <el-input
                v-model="FormMixSubmitData.email"
                placeholder="your@email.com"
              >
              </el-input>
            </el-form-item>
          </ValidationProvider>
        </div>

        <div class="row pt-4">
          <div class="col-md-6">
            <BaseButton
              class="isStylePrimary isOutline3 isFull isRadius mb-3 mb-md-0"
              @click="$FormMixinOnResetSubmitData"
            >
              取消
            </BaseButton>
          </div>
          <div class="col-md-6">
            <BaseButton
              :disabled="invalid"
              :loading="$isLoading('storeMember')"
              class="isStyleSecondary isFull isRadius"
              type="submit"
            >
              儲存修改
            </BaseButton>
          </div>
        </div>
      </el-form>
      <BasePre>FormMixSubmitData: {{ FormMixSubmitData }}</BasePre>
    </ValidationObserver>
  </MemberLayout>
</template>
<!-- section style -->
<style lang="scss" module>
.formInfo {
  :global {
    .formInfo {
      @include unstyled;
    }
  }
}
</style>
